import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import Header from '@/common/header';
import { bai_jamjuree } from '@/public/assets/fonts/Bai-Jamjuree';
import { jetbrainsMono } from '@/public/assets/fonts/JetBrains-Mono';
import { outfit } from '@/public/assets/fonts/Outfit';

import { Footer } from '../../footer';
import type { DefaultTrialProps } from '../../trial-layout-switcher';
import { TrialModal } from './components/trial-modal';
import { BeforeAfter } from './sections/before-after';
import { Experience } from './sections/experience';
import { Faq } from './sections/faq';
import { FinalCta } from './sections/final-cta';
import { Games } from './sections/games';
import { Hero } from './sections/hero';
import { HowItWorks } from './sections/how-it-works';
import { MultiInternet } from './sections/multi-internet';
import { Multiconnection } from './sections/multiconnection';
import { Stats } from './sections/stats';

interface TrialBetaProps extends DefaultTrialProps {}

export function TrialBeta({ daysTrial, trialConfigId, trialPageId, isDisabledButton }: TrialBetaProps) {
  const { t } = useTranslation('components/trial/lp/trial-beta');
  // Owned here so the experience section's and final CTA's buttons, and the modal's own close
  // paths (Escape, backdrop, close button), all drive the same piece of state.
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <Head>
        {/* Served raw from /public rather than appended to global.css: 2,063 lines would grow the
            global sheet by 55% and download on every route. See spec D-2. */}
        <link rel='stylesheet' href='/css/trial-beta.css' />
      </Head>
      <div className={`${bai_jamjuree.className} ${outfit.variable} ${jetbrainsMono.variable}`}>
        <Header variant='primary' />
        <main className='trial-beta-page'>
          <Hero daysTrial={daysTrial} trialConfigId={trialConfigId} trialPageId={trialPageId} isDisabledButton={isDisabledButton} />
          <Multiconnection />
          <MultiInternet />
          <BeforeAfter />
          <Experience onOpenModal={handleOpenModal} />
          <HowItWorks />
          <Stats />
          <Games />
          <Faq />
          <FinalCta daysTrial={daysTrial} onOpenModal={handleOpenModal} />
          <TrialModal isOpen={isModalOpen} onClose={handleCloseModal} daysTrial={daysTrial} trialConfigId={trialConfigId} trialPageId={trialPageId} isDisabledButton={isDisabledButton} />
        </main>
        <Footer variant='minimal' text={t('footer', { year: new Date().getFullYear() })} />
      </div>
    </>
  );
}
